export default __webpack_public_path__ + "static/media/pdf_preview.a408551e.svg";